import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '@services/auth.service';
import { Observable } from 'rxjs/observable';
import "rxjs/add/operator/map";
import { CommonService } from '@shared/services/common';
import { CommonMethods } from '@services/common.method';
import { StatesService } from '@shared/services/states';
import { of } from 'rxjs';

@Injectable()
export class RouteGuardService implements CanActivate {
  constructor(
    private auth: AuthService,
    private router: Router,
    private httpCommon: CommonService,
    private commonMethod: CommonMethods,
    private statesService: StatesService
  ) { }
  canGoToRoute(user: string, id: string): boolean {
    return true;
  }
  canLoad(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (CommonMethods.CheckNullOrUndefined(this.auth.getCompanyId()) || CommonMethods.CheckNullOrUndefined(this.auth.getToken())) {
      setTimeout(() => {
        this.auth.clearStorage();
        this.router.navigate(["/login"]);
      }, 0
      );
      return false;
    }
    return true;
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    //let path =route.url[0].path;
    if (CommonMethods.CheckNullOrUndefined(this.auth.getCompanyId()) || CommonMethods.CheckNullOrUndefined(this.auth.getToken())) {
      setTimeout(() => {
        this.auth.clearStorage();
        this.router.navigate(["/login"]);
      }, 0
      );
      return false;
    }
    return this.httpCommon.GetIntialData(this.auth.getCompanyId(), "CodeTypeData")
      .map(response => {
        let val = true;
        if (!CommonMethods.CheckNullOrUndefined(this.auth.getToken()) && !CommonMethods.CheckNullOrUndefined(response)) {
          this.statesService.setStates(response.CodeTypeData.WorkTicketStatus);
          this.statesService.setSubStates(response.CodeTypeData.WorkTicketSubStatus);
          this.commonMethod.setCompany(response);
          return val;
        }
        else {
          this.logout();
        }

      }, error => {
        this.logout();
      }).catch(error => {
        return this.logout();
      }
      )
  }
  private logout() {
    setTimeout(() => {
      this.auth.clearStorage();
      this.router.navigate(["/login"]);
    }, 0
    );
    return of(false);
  }
}